import { useEffect } from 'react';
import { useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import { pushPageView } from '../services/gtm';

// Google Analytics (GTM)
const PageViewTracker = () => {
  const location = useLocation();
  const { user } = useSelector((state: any) => state.userAuth);

  useEffect(() => {
    pushPageView(user, {
      'page_location': window.location.origin,
      'page_path': location.pathname,
      'query': location.search,
      'user_id': user.external_id ?? '',
      'external_id': user.external_id ?? '',
    })

    // パスが変わった時のみ
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return null;
};

export default PageViewTracker;